export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxNl4c_SjTjQJElti5.77d470bc.woff2";